import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
/*import MySwiper from "./MySwiper.jsx";*/
import OfficeSlider from './OfficeSlider';
import NewPatientBanner from './NewPatientBanner';
// import Testimonials from './Testimonials'; // Removed for this release, keep for future use
import { SectionHeading } from './SectionHeading';

const HomepageFAQ = () => {
    const [activeIndex, setActiveIndex] = React.useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const homepageFaqs = [
        {
            question: "What are your office hours?",
            answer: "Our office is open Monday & Friday from 9:00 AM to 6:00 PM and Tuesday through Thursday 9:00 AM to 5:00 PM. We are closed on weekends and major holidays.",
            hasLink: true,
            linkText: "View Office Hours",
            linkUrl: "/contact#hanover"
        },
        {
            question: "How do I schedule an appointment?",
            answer: "You can schedule an appointment by calling our office at (781) 871-5030.",
            hasLink: true,
            linkText: "Contact Us",
            linkUrl: "/contact"
        },
        {
            question: "Do you accept walk-in patients?",
            answer: "We do not accept walk-in patients. All visits are by appointment only to ensure we can provide the best care for all our patients. Same day appointments are available.",
            hasLink: true,
            linkText: "View Office Policy",
            linkUrl: "/OfficeInfo/OfficePolicy"
        },
        {
            question: "What insurance plans do you accept?",
            answer: "We accept most major insurance plans. Please visit our Insurance page for a complete list of accepted insurance providers.",
            hasLink: true,
            linkText: "View Insurance Plans",
            linkUrl: "/OfficeInfo/Insurances"
        },
        {
            question: "How do I get my test results?",
            answer: "Test results are typically available within 3-5 business days. You can access your results through our patient portal, Quest Diagnostics, by setting up a password and logging in.",
            hasLink: true,
            linkText: "Patient Portal",
            linkUrl: "https://www.questdiagnostics.com/"
        }
    ];

    return (
        <div className="faq-list">
            {homepageFaqs.map((item, index) => (
                <div
                    key={index}
                    className={`faq-item ${activeIndex === index ? 'open' : ''}`}
                >
                    <div className="faq-question" onClick={() => toggleAccordion(index)}>
                        <h4>{item.question}</h4>
                        <span className="faq-icon">{activeIndex === index ? '-' : '+'}</span>
                    </div>
                    <div
                        className="faq-answer"
                        style={{
                            maxHeight: activeIndex === index ? '500px' : '0',
                            opacity: activeIndex === index ? '1' : '0',
                            paddingTop: '1rem'
                        }}
                    >
                        <p>
                            {item.answer}
                            {item.hasLink && (
                                <>
                                    <br /><br />
                                    <a 
                                        href={item.linkUrl}
                                        style={{ 
                                            color: '#0ba360',
                                            textDecoration: 'none',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease',
                                            backgroundColor: 'transparent'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.color = '#0ba360';
                                            e.target.style.textDecoration = 'none';
                                            e.target.style.backgroundColor = 'transparent';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.color = '#0ba360';
                                            e.target.style.textDecoration = 'none';
                                            e.target.style.backgroundColor = 'transparent';
                                        }}
                                        onFocus={(e) => {
                                            e.target.style.color = '#0ba360';
                                            e.target.style.textDecoration = 'none';
                                            e.target.style.backgroundColor = 'transparent';
                                        }}
                                    >
                                        {item.linkText} →
                                    </a>
                                </>
                            )}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};

const Header = () => {
    const handleOfficePolicyClick = () => {
        // Scroll to top when office policy link is clicked
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    };

	return (	
		<>
		    <section className="header">
		        <NewPatientBanner />
			    <div className="hero-section">
			        <div className="hero-content">
			            <div className="hero-text">
			                <span>Welcome to</span>
			                <h1>Atlantic Primary Care</h1>
			                <p>
							Serving Hanover and the South Shore with 
							compassionate, comprehensive primary care for over 30 years. Our dedicated team provides personalized medical care for adult patients with a focus on preventive care, chronic disease management, and acute care services. We're committed to your wellness, comfort, and peace of mind through exceptional healthcare delivery.
			                </p>
			                <div className="hero-buttons">
			                    <a href="https://www.questdiagnostics.com/" target="_blank" rel="noopener noreferrer" className="primary-button">
			                        Patient Portal
			                    </a>
			                    <a href="/contact" className="secondary-button">
			                        Contact Us
			                    </a>
			                </div>
			            </div>
			            <div className="hero-slider">
			                <OfficeSlider />
			            </div>
			        </div>
			    </div>
				
				<section className="about-header-section">
				<SectionHeading
					title="Exceptional care for your family"
					description="At Atlantic Primary Care, we've been serving our community for over 30 years. Our mission is to provide high-quality, compassionate healthcare that addresses both your immediate needs and long-term wellness goals."
				/>
				<div className="care-cards-container">
					<div className="care-card">
						<div className="care-icon">
							<i className="fas fa-user-md"></i>
						</div>
						<h4>Managing Illness</h4>
						<p>Personalized, evidence-based care plans to effectively manage chronic conditions and support long-term health and quality of life.</p>
						<div className="care-card-overlay">
							<h4>Managing Illness</h4>
							<p>Personalized, evidence-based care plans to effectively manage chronic conditions and support long-term health and quality of life.</p>
							<div className="overlay-features">
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Chronic Disease Management</span>
								</div>
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Treatment Plans</span>
								</div>
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Long-term Care</span>
								</div>
							</div>
						</div>
					</div>

					<div className="care-card">
						<div className="care-icon">
							<i className="fas fa-eye"></i>
						</div>
						<h4>Prevention</h4>
						<p>Comprehensive screenings and wellness exams designed to detect issues early and support long-term, proactive care.</p>
						<div className="care-card-overlay">
							<h4>Prevention</h4>
							<p>Comprehensive screenings and wellness exams designed to detect issues early and support long-term, proactive care.</p>
							<div className="overlay-features">
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Health Screenings</span>
								</div>
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Wellness Exams</span>
								</div>
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Early Detection</span>
								</div>
							</div>
						</div>
					</div>

					<div className="care-card">
						<div className="care-icon">
							<i className="fas fa-syringe"></i>
						</div>
						<h4>Immunizations</h4>
						<p>Vaccination needs will be addressed, including annual flu shots and pneumonia vaccines which are available in the office to keep you and your family protected year-round.</p>
						<div className="care-card-overlay">
							<h4>Immunizations</h4>
							<p>Vaccination needs will be addressed, including annual flu shots and pneumonia vaccines which are available in the office to keep you and your family protected year-round.</p>
							<div className="overlay-features">
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Flu Shots</span>
								</div>
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Pneumonia Vaccines</span>
								</div>
								<div className="feature">
									<i className="fas fa-check-circle"></i>
									<span>Year-round Protection</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				</section>

        <div className="service-section" id="services">
          <SectionHeading
            title="Our Services"
            description="Below are a few of our listed services that we offer when making a patient appointment with us."
          />
          <div className="services-grid">
            <div className="service service1">
              <i className="ti-bar-chart"></i>
              <h4>Primary Care</h4>
              <p>Comprehensive medical care for adult patients (18+), including routine check-ups, sick visits, preventive care, and management of chronic conditions. Our personalized approach ensures every patient receives the attention and care they deserve.</p>
              <Link to="/OfficeInfo/OfficePolicy" className="cta" onClick={handleOfficePolicyClick}>Read More <span className="ti-angle-right"></span></Link>
            </div>

            <div className="service service2">
              <i className="ti-light-bulb"></i>
              <h4>Telehealth Options</h4>
              <p>Virtual consultations and follow-up visits from the comfort of your home, providing convenient access to healthcare when you need it. Our telehealth services ensure you receive quality care without leaving your home, making healthcare more accessible and convenient.</p>
              <a href="./OfficeInfo/Telemedicine" className="cta">Read More <span className="ti-angle-right"></span></a>
            </div>

            <div className="service service3">
              <i className="ti-money"></i>
              <h4>Health Monitoring</h4>
              <p>Stay on top of your health with regular check-ups, lab work, and evaluations that help track your well-being. Our comprehensive health monitoring services help you maintain optimal health and catch potential issues early for better outcomes.</p>
              <Link to="/OfficeInfo/OfficePolicy" className="cta" onClick={handleOfficePolicyClick}>Read More <span className="ti-angle-right"></span></Link>
            </div>
          </div>
        </div>

                {/* Testimonials section removed for this release - keep files for future use */}
                {/* <div className="testimonials-section">
                    <Testimonials/>
                </div> */}
				
                <section className="faq-section">
                    <div className="faq-container">
                        <SectionHeading
                            title="Common Questions About Our Practice"
                            description="Get quick answers to frequently asked questions about our services, appointments, and policies."
                        />
                        <div className="faq-list">
                            <HomepageFAQ />
                        </div>
                    </div>
                </section>
						
            </section>
		</>
    );
}

export default Header;